import { render, staticRenderFns } from "./formsubedit.vue?vue&type=template&id=4436bc58&scoped=true"
import script from "./formsubedit.vue?vue&type=script&lang=js"
export * from "./formsubedit.vue?vue&type=script&lang=js"
import style0 from "./formsubedit.vue?vue&type=style&index=0&id=4436bc58&prod&lang=css"
import style1 from "./formsubedit.vue?vue&type=style&index=1&id=4436bc58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4436bc58",
  null
  
)

export default component.exports